module.exports = __webpack_public_path__ + "static/section-two-d1a9f54ce5f778649ffa18a9bf756cd4.png";